import { Link } from "react-router-dom";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { PawPrint } from "lucide-react";

interface AuthShellProps {
  title: string;
  description?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
}

export const AuthShell = ({ title, description, children, footer }: AuthShellProps) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary/5 via-background to-accent/5 flex flex-col items-center justify-center p-4">
      <Link
        to="/"
        className="flex items-center gap-3 mb-6 hover:opacity-80 transition-opacity"
        aria-label="Strona główna GdzieSchronisko"
      >
        <span className="bg-primary rounded-lg flex items-center justify-center w-10 h-10 flex-shrink-0">
          <PawPrint className="text-primary-foreground w-5 h-5" />
        </span>
        <span
          className="font-extrabold text-primary text-xl leading-tight"
          style={{ letterSpacing: "-0.5px" }}
        >
          GdzieSchronisko
        </span>
      </Link>
      <Card className="w-full max-w-md shadow-lg">
        <CardHeader>
          <CardTitle className="text-2xl">{title}</CardTitle>
          {description && <CardDescription>{description}</CardDescription>}
        </CardHeader>
        <CardContent className="space-y-4">{children}</CardContent>
      </Card>
      {footer && <div className="mt-4 text-sm text-muted-foreground text-center">{footer}</div>}
    </div>
  );
};
